import { CONNECTION_ROBOT, AGORA_TOKEN, CLEAR_REDUX } from "../actionTypes";

const initialState = {
    robotConnect: 'Disconnected',
    connectionColor: '#FF0000',
    agoraToken: {}
}

export const robotConnectionsReducer = (state = initialState, action) => {
    const { payload } = action
    switch (action.type) {
        case CONNECTION_ROBOT:
            return {
                ...state,
                robotConnect: payload.robotConnect,
                connectionColor: payload.connectionColor
            }
        case AGORA_TOKEN:
            return {
                ...state,
                agoraToken: payload,
            }
        case CLEAR_REDUX:
            return initialState;
        default:
            return state;
    }

}
